import localforage from 'localforage';
import { getUserEvents, LOCAL_USER_EVENTS_KEY } from './get-user-events';
import { createBrowserClientSupa } from './supabase/createBrowserClient';

export const trackSiteVisit = async (userId?: string) => {
  if (!userId) {
    const { data: userEvents, error } = await getUserEvents();
    if (error) {
      // TO-DO: Deal with this error
      console.log('Error getting user events from local:', error);
      return;
    }
    const newUserEvents = [
      ...userEvents,
      {
        event_type: 'visit',
        example_id: null,
        user_id: 'local',
        created_at: new Date().toISOString(),
      },
    ];

    await localforage.setItem(LOCAL_USER_EVENTS_KEY, newUserEvents);
    return;
  }
  const supabase = createBrowserClientSupa();
  const { error } = await supabase
    .from('user_events')
    .insert({ user_id: userId, event_type: 'visit' });
  if (error) {
    console.log('error', error);
  }
};
